import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Typography from '../Typography';
import { stringReplacer } from '@quikr/ui/src/helpers/common';
import { Assured, Gold, Spotlight } from '@quikr/ui/src/icons';

const Label = styled(Typography)`
  margin-right: 10px;
  @media screen and (max-width: 767px) {
    margin-right: 15px;
  }
  ${({ type }) => {
    switch (type) {
      case 'GOLD':
      case 'GOLD_URGENT':
        return css`
          color: ${({ theme }) => theme.colors.Gold};
        `;
      case 'SPOTLIGHT':
        return css`
          color: ${({ theme }) => theme.colors.Spotlight};
        `;
    }
  }}
  ${({ type }) =>
    type === 'ASSURED' &&
    css`
      margin-top: -5px;
      margin-bottom: -5px;
    `}
`;

const SpotlightTag = styled(Spotlight)`
  width: 19px;
  margin-right: 8px;
  @media screen and (max-width: 767px) {
    width: 11px;
    margin-right: 8px;
  }
`;

const GoldTag = styled(Gold)`
  width: 20px;
  margin-right: 8px;
  @media screen and (max-width: 767px) {
    width: 13px;
    margin-right: 8px;
  }
`;

const AssuredTag = styled(Assured)`
  width: 72px;
`;

const JobsTag = props => {
  const { pageType = '', type, ...rest } = props;

  return (
    <Label
      tagName="span"
      modifiers={[pageType === 'snb' ? 'bt3' : 'bt2', 'bold']}
      className="dFA ttU"
      type={type}
      {...rest}
    >
      {type === 'SPOTLIGHT' ? <SpotlightTag /> : type === 'ASSURED' ? <AssuredTag /> : <GoldTag />}
      {type !== 'ASSURED' && stringReplacer(type === 'GOLD_URGENT' ? 'GOLD' : type, '_', ' + ')}
    </Label>
  );
};

JobsTag.propTypes = {
  type: PropTypes.oneOf(['ASSURED', 'GOLD', 'SPOTLIGHT', 'GOLD_URGENT']),
  pageType: PropTypes.string
};

export default JobsTag;
